import { lazy } from 'react';

const RewardsPage = lazy(() => import('./RewardsPage'));
const RewardsLevelsPage = lazy(() => import('./RewardsLevelsPage'));

export { RewardsPage, RewardsLevelsPage };
